import { http } from "./http";

export type VneReportListItem = {
  id: string;
  posCode?: string | null;
  hostname?: string | null;
  source: string;
  status: string;
  summary: {
    overallStatus?: string;
    headline?: string;
    vneDetected?: boolean;
    easyRetailDetected?: boolean;
    gapCounts?: { high: number; medium: number; low: number; info: number };
  };
  analyzedAt: string;
  createdAt: string;
  location?: string | null;
};

export type VneGap = {
  id: string;
  severity: "HIGH" | "MEDIUM" | "LOW" | "INFO" | string;
  area: string;
  title: string;
  detail: string;
  action?: string;
};

export type VneReportDetail = {
  ok: boolean;
  report: {
    id: string;
    posCode?: string | null;
    hostname?: string | null;
    source: string;
    status: string;
    summary: Record<string, unknown>;
    findings: Record<string, unknown>;
    gaps: VneGap[];
    recommendations?: {
      nextSteps?: Array<{ priority: string; title: string; action: string }>;
    };
    natSnapshot?: Record<string, unknown>;
    rawPayload?: Record<string, unknown>;
    analyzedAt: string;
    createdAt: string;
    posDevice?: {
      code: string;
      name: string;
      location?: { name: string; code: string };
    } | null;
  };
};

export const vneApi = {
  list(token: string, limit = 30) {
    return http<{ ok: boolean; items: VneReportListItem[] }>(
      `/pos/vne/analysis?limit=${limit}`,
      { method: "GET" },
      token,
    );
  },
  getById(token: string, id: string) {
    return http<VneReportDetail>(`/pos/vne/analysis/${id}`, { method: "GET" }, token);
  },
};
